import { useCallback } from "react";

import { useTranslation } from "next-i18next";

import { copyTableFallback } from "@/common/utils/copy-table.utils";
import {
  PRO_PROJECTS_COPY,
  PRO_PROJECTS_NAMESPACE,
  ProProjectsCopyKey,
} from "@/features/pro-buyer-projects/static/pro-buyer-projects.static";

/**
 * `t()` over the WHO-5959 copy table. The fallback, while Lokalise or the
 * namespace is missing, is the table's text in the page's own language.
 */
export const useProProjectsCopy = () => {
  const { t, i18n } = useTranslation();
  const language = i18n?.language;

  const tc = useCallback(
    (copyKey: ProProjectsCopyKey, values?: Record<string, string | number>) =>
      t(`${PRO_PROJECTS_NAMESPACE}:${PRO_PROJECTS_COPY[copyKey].key}`, {
        defaultValue: copyTableFallback(PRO_PROJECTS_COPY[copyKey], language),
        ...values,
      }),
    [t, language]
  );

  /** WHO-5959 F5: "1 aankoop", "2 aankopen". */
  const purchaseCountLabel = useCallback(
    (count: number) =>
      tc(count === 1 ? "purchaseCountOne" : "purchaseCount", { count }),
    [tc]
  );

  return { tc, purchaseCountLabel };
};
